<script setup lang="ts">
import { PopoverArrow, PopoverContent, PopoverPortal, PopoverRoot, PopoverTrigger } from 'reka-ui'

import { cn } from './classes'

/**
 * Popover — filtre nad tabuľkou, rozpad ceny na mobile, výber stĺpcov.
 *
 * Na rozdiel od tooltipu smie obsahovať interaktívne prvky a otvára sa klikom,
 * takže je použiteľný z klávesnice aj z dotyku.
 */
const props = withDefaults(
	defineProps<{
		/** Popis spúšťača pre čítačku, keď je v ňom len ikona. */
		accessibleNameSk?: string
		side?: 'top' | 'right' | 'bottom' | 'left'
		align?: 'start' | 'center' | 'end'
		width?: string
	}>(),
	{ side: 'bottom', align: 'start', width: 'w-(--panel-w-narrow)' },
)

const open = defineModel<boolean>('open', { default: false })
</script>

<template>
	<PopoverRoot v-model:open="open">
		<PopoverTrigger as-child :aria-label="props.accessibleNameSk">
			<slot name="trigger" />
		</PopoverTrigger>

		<PopoverPortal>
			<PopoverContent
				:side="props.side"
				:align="props.align"
				:side-offset="4"
				:class="cn('z-(--z-dropdown) rounded-lg border border-border bg-surface-raised p-3 shadow-md', props.width)"
			>
				<slot />
				<PopoverArrow class="fill-[var(--color-surface-raised)]" :width="10" :height="5" />
			</PopoverContent>
		</PopoverPortal>
	</PopoverRoot>
</template>
